import React from "react"
import { Link, graphql } from "gatsby"
import Moment from "moment";

import Layout from "../components/layout"
import Seo from "../components/seo"
import Sidebar from "../components/sidebar"

export default function BlogPostList({data, pageContext}) {
  const { edges } = data.allMarkdownRemark;
  const { currentPage, numPages } = pageContext
  const isFirst = currentPage === 1
  const isLast = currentPage === numPages
  const prevPage = currentPage - 1 === 1 ? "/blog" : (currentPage - 1).toString()
  const nextPage = (currentPage + 1).toString()

  return(
    <Layout>
    <Seo title="Blog" />
    <div className="flex flex-wrap flex-col-reverse lg:flex-row flex-col-reverse">
      <div className="w-full lg:w-3/12">
        <Sidebar></Sidebar>
      </div>
      <div className="w-full lg:w-9/12 lg:pl-20">
        <h1 className="blog-title text-5xl font-bold tracking-tighter mb-1">Blog</h1>

        <div className="blog-description text-2xl tracking-tighter mb-6">
          Electronics and embedded development.
        </div>

        <hr className="mb-4"/>

        <div>
          { edges.map((edge, index )=> {
            const { frontmatter } = edge.node

            return (
                <div key={index.toString()} className="blog-post-item mb-8">
                  <Link to={frontmatter.path}>
                    <h2 className="text-3xl font-bold tracking-tighter mb-2">
                      {frontmatter.title}
                    </h2>
                  </Link>
                  <div className="mb-2 italic">
                    Posted on{' '}
                    <time>
                      {Moment(new Date(frontmatter.date)).format(
                        'Do MMM YYYY'
                      )}
                    </time>
                  </div>
                  <div className="mb-6">
                    {frontmatter.summary}
                  </div>
                  <div>
                    <Link to={frontmatter.path}>
                      <span className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700 hover:border-blue-500 rounded">Read More</span>
                    </Link>
                  </div>
                </div>    
            )
          }) }
        </div>

        {!isFirst && (
          <Link to={prevPage} rel="prev">
            <span className="mx-2">
              ← Previous Page
            </span>
          </Link>
        )}
        
        {Array.from({ length: numPages }, (_, i) => (
          <Link key={`pagination-number${i + 1}`} to={`${i === 0 ? "/blog" : "/blog/"+(i + 1)}`}>
            <span className={`mx-2 ${ i+1 === currentPage ? 'font-bold text-blue-700' : '' }`}>
              {i + 1}
            </span>
          </Link>
        ))}

        {!isLast && (
          <Link to={nextPage} rel="next">
            <span className="mx-2">
              Next Page →
            </span>
          </Link>
        )}

      </div>
    </div>
  </Layout>
  )
}

export const blogListQuery = graphql`
  query($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          id
          frontmatter {
            path
            title
            summary
            date
          }
        }
      }
    }
  }
`